export default "__VITE_ASSET__CIBZ7r5D__"